var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.499999",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: 9780468724
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.125 1.113281 L 33.375 1.113281 L 33.375 36.363281 L 16.125 36.363281 Z M 16.125 1.113281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d36b611d9c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.347656 1.113281 L 27.597656 1.113281 L 27.597656 36.363281 L 10.347656 36.363281 Z M 10.347656 1.113281 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9780468724)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#118e47",
    d: "M 16.160156 1.109375 L 16.160156 36.363281 L 29.199219 23.890625 C 30.496094 22.601562 32.03125 20.796875 33.328125 19.714844 L 24.773438 10.4375 C 24.359375 9.921875 24.125 9.820312 23.710938 9.304688 L 16.160156 1.109375 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d36b611d9c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5791f",
    d: "M 10.382812 1.109375 L 10.382812 36.363281 L 23.421875 23.890625 C 24.722656 22.601562 26.253906 20.796875 27.554688 19.714844 L 18.996094 10.4375 C 18.585938 9.921875 18.347656 9.820312 17.9375 9.304688 L 10.382812 1.109375 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpsIcon);
export default __webpack_public_path__ + "static/media/imps_icon.a4c54211d7b4701efbb4b03d08b6c269.svg";
export { ForwardRef as ReactComponent };